<template>
  <el-table class="m-b" :data="supplierList">
    <el-table-column label="序号" type="index"></el-table-column>
    <el-table-column label="供应商名称" prop="supplierName"></el-table-column>
    <el-table-column label="谈判回复" :formatter="formatter1"></el-table-column>
    <el-table-column label="回复时间" :formatter="formatter2"></el-table-column>
  </el-table>
</template>

<script>
import { getValue } from '../../../../lib/enum'
import dayjs from 'dayjs'
import store from '@/store'
export default {
  props: {
    inquireId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      supplierList: []
    }
  },
  created() {
    // TODO 接口不对，要专门获取发起供应商，而不是所有
    store
      .dispatch('listSupplierNegoByInquireId', {
        inquireId: this.inquireId
      })
      .then((res) => {
        this.supplierList = res
      })
  },
  methods: {
    formatter1(row) {
      return getValue('backStatus', row.backStatus)
    },
    formatter2(row) {
      return row.backTime && dayjs(row.backTime).format('YYYY-MM-DD HH:mm:ss')
    }
  }
}
</script>

<style></style>
